var _defs, _circle, _circle2, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolPack376({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.c{fill:#fff;}.a,.b{stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}.b{fill:none;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 8,
    cy: 5.25,
    r: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 8,
    cy: 12.24,
    r: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M11.42.76V2.62A1.47,1.47,0,0,0,12,1.41C12,.84,11.8.76,11.42.76Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M11.19.76V2.62a1.49,1.49,0,0,1-.54-1.21C10.65.84,10.82.76,11.19.76Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M4.81.76V2.62a1.49,1.49,0,0,0,.54-1.21C5.35.84,5.18.76,4.81.76Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M4.58.76V2.62A1.47,1.47,0,0,1,4,1.41C4,.84,4.2.76,4.58.76Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolPack376);
export default __webpack_public_path__ + "static/media/Symbol_pack_376.02f0e5127619d20c28abfeda8f7b2199.svg";
export { ForwardRef as ReactComponent };